var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"dropoff-path",style:({
       left: _vm.layout.width - 10 - Math.min(9, (Math.max(0, _vm.dropPathInfo.width - 10))) + 'px',
       top: _vm.top + 'px'
     }),attrs:{"width":"60","height":"120"}},[_c('ba-node-dropoff-path',{attrs:{"nodeData":_vm.nodeData,"layout":_vm.layout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }